import Profile from '../pages/Profile'
import Work from '../pages/Work'
import Education from '../pages/Education'
import Contact from '../pages/Contact'
import Communication from '../pages/Communication'
import Network from '../pages/Network'
import Topics from '../pages/Topics'
import Membership from '../pages/Membership'
import CreateAccount from '../pages/CreateAccount'

export const ONBOARDING_STEPS = [
  {
    title: 'Create Your Account',
    description:
      'The following information is required to create your MyATD account.',
    component: CreateAccount,
  },
  {
    title: 'Profile Settings & Bio',
    description: '',
    component: Profile,
  },
  {
    title: 'Work',
    description: '',
    component: Work,
  },
  {
    title: 'Education',
    description: '',
    component: Education,
  },
  {
    title: 'Contact',
    description: '',
    component: Contact,
  },
  {
    title: 'Communication Preferences',
    description: '',
    component: Communication,
  },
  {
    title: 'Build Your Network',
    description: '',
    component: Network,
  },
  {
    title: 'Follow Your Topic',
    description: '',
    component: Topics,
  },
  {
    title: 'Become A Member',
    description: '',
    component: Membership,
  },
]
